import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import {
  LineSelectedCell
} from '../model';
import {
  PLANNER_CLICK_CELL,
} from 'apps/events';
import PlannerControllerBase from './base';
export default class CellsController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.customEvent(PLANNER_CLICK_CELL, (e) => { this.onClickCell(e) });
  }
  // 空いている日付のセルがクリックされた
  onClickCell(e){
    let cell:LineSelectedCell = e.detail;
    let dateStr = cell.toString();
    this.updateData({
      black_over: {
        show: true
      },
      forms_schedules_create: {
        inputs: {
          daterange: {
            value: dateStr + ',' + dateStr
          },
          line_id: {
            value: cell.lineId
          },
          phase_id: {
            value: ''
          }
        }
      }
    })
    this.updatePlanner({
      orders_planner: {
        selectedCell: cell,
        createSchedule: cell,
        selectedSchedule: null,
        selectedTask: null
      }
    });
  }
}
